module.exports = __webpack_public_path__ + "static/media/iot.12b5285c.pdf";